import { render } from "./CaiGouFuKuanDetail.vue?vue&type=template&id=6ec6293c"
import script from "./CaiGouFuKuanDetail.vue?vue&type=script&lang=js"
export * from "./CaiGouFuKuanDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__